var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-242.3 372.1 50 50",
    style: {
      enableBackground: "new -242.3 372.1 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\r\n\t.st0{fill:#FFFFFF;}\r\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_33_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1_",
    className: "st0",
    points: "-214.3,387.8 -211.1,379.7 -193.3,422.2 -199.7,422.2 -204.9,409.7 -223.3,409.7  -220.9,404.2 -207.6,404.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    className: "st0",
    points: "-208.9,416.3 -206.7,422.2 -241.3,422.2 -220.5,372 -213.7,372 -231.9,416.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.4b0eb9b85c88b95d3afa9ac8443db768.svg";
export { ForwardRef as ReactComponent };